// extracted by mini-css-extract-plugin
export default {"popup":"popup_popup__pMaor","close":"popup_close__b9GuV","popup-container":"popup_popup-container__ne924","page":"popup_page__aSSzL","visible":"popup_visible__DauWR"};